import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");

const stripeHeaders = new HttpHeaders()
  .set("Authorization", 'Bearer' + '' + GlobalService.stripeSecretKey)

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  public stripePublishKey: string = GlobalService.stripePublishKey
  public stripeSecretKey: string = GlobalService.stripeSecretKey
  private url = GlobalService.serverURL;
  public stripeURL: string = GlobalService.stripeUrl;
  constructor(
    private http: HttpClient,
  ) { }

  getCustomerId() {
    return this.http.get(this.url + 'course/stripe_payment/create_cus_id', { headers })
  }
  getCustomerIdCompnay() {
    return this.http.get(this.url + 'course_builder/stripe_payment/create_cus_id', { headers })
  }

  GetPaymentIntentId = (data): any => {
    return this.http.post(this.url + 'course/stripe_payment', data, { headers })
  }

  IndexOrderPlace = (data): any => {
    return this.http.post(this.url + 'course/stripe_payment/index_order_place', data, { headers })
  }

  GetPaymentIntentIdIndividual = (data): any => {
    return this.http.post(this.url + 'individual/stripe_payment', data, { headers })
  }

  IndexOrderPlaceIndividual = (data): any => {
    return this.http.post(this.url + 'individual/stripe_payment/index_order_place', data, { headers });
  }

  GetPaymentIntentIdCourseBuilder = (data): any => {
    return this.http.post(this.url + 'course_builder/stripe_payment', data, { headers })
  }

  IndexOrderPlaceCourseBuilder = (data): any => {
    return this.http.post(this.url + 'course_builder/stripe_payment/index_order_place', data, { headers })
  }

  GetPaymentIntentIdPackage = (data): any => {
    return this.http.post(this.url + 'package/stripe_payment', data, { headers })
  }

  IndexOrderPlacePackage = (data): any => {
    return this.http.post(this.url + 'package/stripe_payment/index_order_place', data, { headers })
  }

  BuyJob = (data): any => {
    return this.http.post(this.url + 'course/buy', data, { headers })
  }

  buyFreeCourse(data) {
    return this.http.post(this.url + 'purchase', data, { headers })
  }
  buyFreeOffer(data) {
    return this.http.post(this.url + 'stripe/buy_free', data, { headers })
  }
  //stripe APIs
  createCard(customerId, tokenId) {
    return this.http.post(this.stripeURL + 'customers/' + customerId + '/sources?source=' + tokenId, null,)
  }
  stripePaymentIntent(id: string) {
    return this.http.post(this.stripeURL + 'payment_intents/' + id, null)
  }
  stripeConfirmPayment(id) {
    return this.http.post(this.stripeURL + 'payment_intents/' + id + '/confirm', null)
  }
  voucherValidation(data) {
    return this.http.post(this.url + 'individual/Voucher/validation', data, { headers })
  }
  purchase(data) {
    return this.http.post(this.url + 'course/purchase', data, { headers })
  }
  payPalPurchase(data) {
    return this.http.post(this.url + 'stripe/course_paypal', data, { headers })
  }
  // API Made for general use on 18/10/2023
  buyItem(data) {
    return this.http.post(this.url + 'stripe/course_stripe', data, { headers })
  }
  companyBuyAdminPackage(data){
    return this.http.post(this.url +'package/stripe_payment', data, { headers })
  }
  itemIndexOrderPlace(data) {
    return this.http.post(this.url + 'stripe/course_stripe/index_order_place', data, { headers })
  }
  createCustomerId(){
    return this.http.get(this.url + 'stripe/course_stripe/create_cus_id', { headers })
  }
}
